import { BrowserRouter as Router, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import QueueMonitor from './components/queue/QueueMonitor';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Renders Login unless already authenticated with no pending key param
function LoginRoute() {
  const [searchParams] = useSearchParams();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated && !searchParams.get('key')) {
    return <Navigate to="/queue" replace />;
  }
  return <Login />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={<LoginRoute />}
        />
        <Route 
          path="/queue" 
          element={
            <ProtectedRoute>
              <QueueMonitor />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/queue" replace />} />
        <Route path="*" element={<Navigate to="/queue" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
